<template>
  <div class="custom-container">
    <div class="wrapper">
      <h1>İptal Ve İade Koşulları</h1>
     <p>Yurtlarburada.com yurtların konum bazlı sistem üzerinde yayınlanması yöntemiyle gelir elde eder ve reklam türleri senelik, aylık, haftalık periyotlar üzerinden ücretlendirilir.</p>
      <p>
        Barınma hizmeti talep eden kullanıcılardan ücret talep edilmez.</p>
      <p>Yurtlarburada.com üzerinde yayınlanan ve barınma hizmeti veren yerler barınma talep eden kullanıcının ihtiyacına yönelik seçenekler sunarlar.
        Ayrıca firmamız, Kullanım Sözleşmesi maddelerinden herhangi birinde belirtilen kuralın/kuralların ihlal edildiğini görmesi durumunda kullanıcının anlaşmasını durdurabilir.</p>
      <p>Yurtlarburada.com da barınma hizmeti veren yerler, ,sözleşme tarihinden itibaren için 3 (üç gün) içerisinde senelik üyelik ücretlerinin iadesi ve üyelik iptalini mail yoluyla destek@yurtlarburada.com mailine bildirim yapmalıdır ve telefon ile iletişime geçerek mailinin ulaşıp ulaşmadığını teyit etmelidirler.Bu yolla yapılan üyelik iptallerinin ödemeleri geri iade edilir. Bu süre dışında kalan süreler için ücret iadesi yapılmaz.</p>
      <p>İstem dışı mükerrer ödemeler olduğunda ödemenin iptal ve iadesi mümkündür.</p>
    </div>

  </div>

</template>

<script>
export default {
  name: 'CancelPolicy'
}
</script>

<style lang="scss">
  @import "../assets/scss/components/user-contract";
</style>
